import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Benefits from "../../components/Services/StaffAugmentation/Benefits"
import Hero from "../../components/Services/StaffAugmentation/Hero"
import PrimaryTechnologies from "../../components/Services/StaffAugmentation/PrimaryTechnologies"
import WhenNecessary from "../../components/Services/StaffAugmentation/WhenNecessary"

const Staff = () => {
  return (
    <Layout>
      <SEO title="Staff Augmentation" />
      <Hero />
      <WhenNecessary />
      <Benefits />
      <PrimaryTechnologies />
    </Layout>
  )
}

export default Staff
